import React from 'react';
import { observer } from 'mobx-react';
import {
  AppBar,
  Box,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  Toolbar,
  ListItemText
} from '@mui/material';
import Icon from '@components/Icon';
import ConfirmModal from '@components/ConfirmModal';

import * as S from './styles.ts';

interface Props {
  children: React.ReactNode
}

import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import stores from '@stores';

const menuItems = [
  {
    id: 1,
    title: 'Projects',
    path: '/admin'
  },
  {
    id: 2,
    title: 'Users',
    path: '/admin/users'
  },
];

const AdminLayout = ({ children }: Props) => {
  const {
    layoutStore: { confirmModal },
  } = stores;

  const isActive = (path: string): boolean => {
    return window.location.pathname === path;
  };

  const drawerWidth = 250;

  return (
    <>
      <Box sx={{ display: 'flex' }}>
        <AppBar position="fixed" sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
          <Toolbar>
            <Typography variant="h3" noWrap component="div" sx={{ color: 'white' }}>
              <S.BackLink to='/'>
                <Icon icon='left-arrow' size={14} />
              </S.BackLink>
              Admin Panel
            </Typography>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            ['& .MuiDrawer-paper']: { width: drawerWidth, boxSizing: 'border-box' },
          }}
        >
          <Toolbar />
          <Box sx={{ overflow: 'auto' }}>
            <List>
              {menuItems.map((el) => (
                <ListItem key={el.id} disablePadding>
                  <S.StyledLink to={el.path} className={isActive(el.path) ? 'active' : ''}>
                    <ListItemButton>
                      <ListItemText primary={el.title} />
                    </ListItemButton>
                  </S.StyledLink>
                </ListItem>
              ))}
            </List>
          </Box>
        </Drawer>
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <Toolbar />
          {children}
        </Box>
      </Box>

      {confirmModal && <ConfirmModal />}
    </>
  );
};

export default observer(AdminLayout);
